import { render, staticRenderFns } from "./ImportDynamicTagsSection.vue?vue&type=template&id=6d654ee8&scoped=true"
import script from "./ImportDynamicTagsSection.vue?vue&type=script&lang=js"
export * from "./ImportDynamicTagsSection.vue?vue&type=script&lang=js"
import style0 from "./ImportDynamicTagsSection.vue?vue&type=style&index=0&id=6d654ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d654ee8",
  null
  
)

export default component.exports